<template>
  <div class="outSideEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="returnList()">{{$t('lang.lab_returnOutSide')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon" :inline="true">
        <!-- 区域名称 -->
        <el-form-item :label="$t('lang.lab_locationArea')" prop="locationArea">
          <el-input v-model="form.locationArea" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_locationArea')"
            class="input" maxlength="20">
          </el-input>
        </el-form-item>
        <br>
        <!-- 项目名称 -->
        <el-form-item :label="$t('lang.lab_projectName')" prop="projectName">
          <el-input v-model="form.projectName" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_projectName')"
            class="input" maxlength="20">
          </el-input>
        </el-form-item>
        <br>
        <!-- 管理业态 -->
        <el-form-item :label="$t('lang.lab_managementFormat')" prop="managementFormat">
          <el-input v-model="form.managementFormat"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_managementFormat')" class="input" maxlength="20">
          </el-input>
        </el-form-item>
        <br>
        <!-- 服务类型 -->
        <el-form-item :label="$t('lang.lab_serviceType')" prop="serviceType">
          <el-input v-model="form.serviceType" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_serviceType')"
            class="input" maxlength="20"></el-input>
        </el-form-item>
        <br>
        <!-- 代办机构 -->
        <el-form-item :label="$t('lang.lab_agentMechanism')" prop="agentMechanism">
          <el-input v-model="form.agentMechanism"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_agentMechanism')" class="input" maxlength="20">
          </el-input>
        </el-form-item>
        <br>
        <!-- 招标总价 -->
        <el-form-item :label="$t('lang.lab_biddingAmount')" prop="biddingAmount">
          <el-input @blur="salaryChange" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.biddingAmount"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_biddingAmount')" class="input" maxlength="9">
          </el-input>
        </el-form-item>
        <br>
        <!-- 招标日期 -->
        <el-form-item :label="$t('lang.lab_biddingDate')" prop="biddingDate" class="dept-name">
          <el-date-picker v-model="form.biddingDate" type="date" :format="$t('lang.lab_DATA')" value-format="timestamp"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_biddingDate')" class="input"></el-date-picker>
        </el-form-item>
        <br>
        <!-- 中标单位 -->
        <el-form-item :label="$t('lang.lab_winUnit')" prop="winUnit">
          <el-input v-model="form.winUnit" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_winUnit')"
            class="input" maxlength="15">
          </el-input>
        </el-form-item>
        <br>
        <!-- 中标价格 -->
        <el-form-item :label="$t('lang.lab_winPrice')" prop="winPrice">
          <el-input @blur="salaryChange1" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.winPrice"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_winPrice')" class="input" maxlength="9">
          </el-input>
        </el-form-item>
        <br>
        <!-- 服务期限 -->
        <el-form-item :label="$t('lang.lab_dateFw')" prop="dateFw" class="dept-name">
          <div class="block">
            <el-date-picker class="input" v-model="form.dateFw" :format="$t('lang.lab_DATA')" value-format="timestamp"
              type="daterange" :range-separator="$t('lang.lab_to')" :start-placeholder="$t('lang.lab_startDate')"
              :end-placeholder="$t('lang.lab_endDate')">
            </el-date-picker>
          </div>
        </el-form-item>
        <br>
        <el-form-item class="footBtn">
          <el-button class="btn-first" @click="resetForm('form')">{{$t('lang.btn_rest')}}</el-button>
          <el-button class="detailbtn" type="primary" :disabled="isCanUse" @click="onSubmit('form')">
            {{$t('lang.btn_save')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:outSideEdit
   *@Description:添加修改外拓信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2021-03-30
   */
  export default {
    data() {
      return {
        isCanUse: false, // 是否可以保存
        form: {
          locationArea: '', // 区域名称
          projectName: '', // 项目名称
          managementFormat: '', // 管理业态
          serviceType: '', // 服务类型
          agentMechanism: '', // 代办机构
          biddingAmount: '', // 招标总价
          biddingDate: '', // 招标日期
          winUnit: '', // 中标单位
          winPrice: '', // 中标价格
          dateFw: [], // 服务期限
        },

        rules: {
          locationArea: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_locationArea'),
            trigger: 'blur'
          }],
          projectName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_projectName'),
            trigger: 'blur'
          }],
          managementFormat: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_managementFormat'),
            trigger: 'blur'
          }],
          serviceType: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_serviceType'),
            trigger: 'blur'
          }],
          agentMechanism: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_agentMechanism'),
            trigger: 'blur'
          }],
          biddingAmount: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_biddingAmount'),
            trigger: 'blur'
          }],
          biddingDate: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_biddingDate'),
            trigger: 'change'
          }],
          dateFw: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_dateFw'),
            trigger: 'change'
          }],
        },
      }
    },
    destroyed() {
      window.localStorage.setItem('outSideForm', JSON.stringify(this.form))
    },
    created() {
      if (window.localStorage.getItem('outSideForm')) {
        this.form = JSON.parse(window.localStorage.getItem('outSideForm'))
      }
      // 获取招标id 有id是编辑  没有id是添加
      this.id = this.$route.query.id
      if (this.id) {
        this.getDetail(this.id)
      }
    },
    methods: {
      // 解决价格输入文字后，输入数字，值为空
      salaryChange(e) {
        this.form.biddingAmount = e.target.value
      },
      // 解决价格输入文字后，输入数字，值为空
      salaryChange1(e) {
        this.form.winPrice = e.target.value
      },
      // 返回列表页
      returnList() {
        this.$router.push({
          name: 'outSide'
        })
      },
      // 招标详情方法
      getDetail(id) {
        let loading = this.$loading()
        this.$get(`/biddingInformation/${id}`).then(res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.form.locationArea = res.biddingInformation.locationArea
              this.form.projectName = res.biddingInformation.projectName
              this.form.managementFormat = res.biddingInformation.managementFormat
              this.form.serviceType = res.biddingInformation.serviceType
              this.form.agentMechanism = res.biddingInformation.agentMechanism
              this.form.biddingAmount = res.biddingInformation.biddingAmount
              this.form.biddingDate = res.biddingInformation.biddingDate
              this.form.winUnit = res.biddingInformation.winUnit
              this.form.winPrice = res.biddingInformation.winPrice
              this.form.dateFw.push(res.biddingInformation.serviceStartTime)
              this.form.dateFw.push(res.biddingInformation.serviceEndTime)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存方法
      onSubmit(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (!this.id) {
              // 新增start
              let params = {
                locationArea: this.form.locationArea,
                projectName: this.form.projectName,
                managementFormat: this.form.managementFormat,
                serviceType: this.form.serviceType,
                biddingDateX: this.form.biddingDate,
                agentMechanism: this.form.agentMechanism,
                biddingAmount: this.form.biddingAmount,
                serviceStartTimeX: this.form.dateFw[0],
                serviceEndTimeX: this.form.dateFw[1],
                winUnit: this.form.winUnit,
                winPrice: this.form.winPrice,
              }
              console.log(params)
              this.$post('/biddingInformation', params).then(res => {
                console.log(res)
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.eagleEye.addSucceed')
                  })
                  this.$router.push({
                    name: 'outSide'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
              // 新增end
            } else {
              // 编辑start
              let params = {
                locationArea: this.form.locationArea,
                projectName: this.form.projectName,
                managementFormat: this.form.managementFormat,
                serviceType: this.form.serviceType,
                biddingDateX: this.form.biddingDate,
                agentMechanism: this.form.agentMechanism,
                biddingAmount: this.form.biddingAmount,
                serviceStartTimeX: this.form.dateFw[0],
                serviceEndTimeX: this.form.dateFw[1],
                winUnit: this.form.winUnit,
                winPrice: this.form.winPrice,
              }
              console.log(params)
              this.$patch(`/biddingInformation/${this.id}`, params).then(res => {
                console.log(res)
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                  this.$router.push({
                    name: 'outSide'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
              // 编辑end
            }
          }
        })
      },
      // 清空方法
      resetForm(form) {
        this.form.locationArea = ''
        this.form.projectName = ''
        this.form.managementFormat = ''
        this.form.serviceType = ''
        this.form.agentMechanism = ''
        this.form.biddingAmount = ''
        this.form.biddingDate = ''
        this.form.dateFw = []
        this.form.winUnit = '' 
        this.form.winPrice = ''
      },
    }
  }
</script>

<style lang="scss">
  .outSideEdit {
    .el-form-item__label {
      margin-top: 15px;
    }

    .input {
      width: 700px !important;
      margin-top: 15px;
    }

    .el-form-item {
      margin-bottom: 15px;
      height: auto;
    }

    .dept-name {
      width: 100%;
      height: 50px;

      .el-form-item__content {
        width: 71%;
      }
    }

    .footBtn {
      margin-top: 20px;
    }
  }
</style>